import { c as _c } from "react/compiler-runtime";
import { FilterChip } from "@components/common/faro-table/faro-table-filter/filter-chip";
import { useFilterQueryParams } from "@hooks/table-filters/use-filter-query-params";
/** A chip for just enabling/disabling a filter. */
export function SingleFilterChip(t0) {
  const $ = _c(9);
  const {
    filteredColumn,
    label,
    item,
    tableType
  } = t0;
  const {
    updateFilterItem
  } = useFilterQueryParams();
  let t1;
  if ($[0] !== filteredColumn || $[1] !== item || $[2] !== tableType || $[3] !== updateFilterItem) {
    t1 = function onChipClicked() {
      updateFilterItem({
        tableType,
        filteredColumn,
        filterId: Object.values(item)[0].id,
        shouldReplaceFilterInColumn: false
      });
    };
    $[0] = filteredColumn;
    $[1] = item;
    $[2] = tableType;
    $[3] = updateFilterItem;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const onChipClicked = t1;
  let t2;
  if ($[5] !== filteredColumn || $[6] !== label || $[7] !== onChipClicked) {
    t2 = <FilterChip filteredColumn={filteredColumn} onClick={onChipClicked} label={label} shouldHaveDropdown={false} />;
    $[5] = filteredColumn;
    $[6] = label;
    $[7] = onChipClicked;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}